'use strict';

import $ from 'jquery';
import mask from 'jquery-mask-plugin';
import Swal from 'sweetalert2';

export const common = () => {
  const $selectSuper = $('.js-superintendent');
  const $selectRegional = $('.js-regional');
  const gtmCategory = 'voluntariado-icea';

  let $modalTrigger = document.getElementById('modal-trigger');

  if ($modalTrigger) {
    const title = $modalTrigger.getAttribute('data-title'),
      type = $modalTrigger.getAttribute('data-type'),
      text = $modalTrigger.getAttribute('data-text');

    Swal.fire({ title: `${title ? title : ''}`, text: `${text ? text : ''}`, icon: `${type ? type : ''}` });
  }

  // Email Protective SPAM Solution
  const $mailContainer = document.querySelectorAll('[data-mail-creator]');

  if ($mailContainer.length) {
    $mailContainer.forEach(el => {
      let $mail = document.createElement('a');
      let arrMail = el.getAttribute('data-mail-creator').split(',');

      if (arrMail.length == 3) {
        let label = arrMail[0].replace(/\s/g, '') + '@' + arrMail[1].replace(/\s/g, '') + arrMail[2].replace(/\s/g, '');
        $mail.setAttribute('href', 'ma' + 'il' + 'to:' + label);
        $mail.textContent = label;
        el.appendChild($mail);
      }
    });
  }

  $('.js-gtm').on('click', function () {
    var title = $(this).attr('data-title');
    var action = $(this).attr('data-action');

    dataLayer = dataLayer || [];
    dataLayer.push({
      event: 'interaction',
      target: gtmCategory,
      action: action,
      'target-properties': title,
    });
  });

  $('.js-gtm-input').on('blur', function () {
    if (this.value.length > 0) {
      var title = $(this).attr('data-title');
      var action = $(this).attr('data-action');

      dataLayer = dataLayer || [];
      dataLayer.push({
        event: 'interaction',
        target: gtmCategory,
        action: action,
        'target-properties': title,
      });
    }
  });

  //Toggle Menu
  document.querySelector('.js-toggle-menu').addEventListener('click', e => {
    e.preventDefault();
    document.body.classList.toggle('nav-active');
  });

  $(document).on('click', '[data-modal-close]', function () {
    $(this).closest('.c-modal').removeClass('is-active');
    $('#modal-form').remove();
  });

  $('.js-modal-warning-logged').on('click', function (e) {
    e.preventDefault();
    Swal.fire({
      html:
        '<h3 class="o-ttl">' +
        $(this).attr('data-title') +
        '</h3>' +
        '<p>Você precisa realizar o seu login na plataforma para visualizar essas informações.</p>',
      padding: '25px 15px',
      position: 'top',
      showConfirmButton: false,
      showClass: {
        popup: 'c-new-swal--popup',
      },
      customClass: 'c-new-swal',
    });
  });

  $(document).on('click', '.js-delete', function (e) {
    e.preventDefault();
    let data_id = $(this).attr('data-id');

    Swal.fire({
      title: 'Excluir registro?',
      text: 'Tem certeza que deseja remover este registro?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#9C63FF',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, excluir registro!',
      cancelButtonText: 'Não excluir',
    }).then(result => {
      if (result.value) {
        var token = $('meta[name="csrf-token"]').attr('content');

        $.ajax({
          headers: {
            'X-CSRF-TOKEN': token,
          },
          url: $(this).attr('data-url'),
          method: 'DELETE',
          success: function (data) {
            Swal.fire(data.title, data.message, data.type);

            if (data.type == 'success') {
              var row = document.getElementById(data_id);
              row.parentNode.removeChild(row);
            }

            if (data.count) {
              $('.js-counter').html(data.count);
            }
          },
        });
      }
    });
  });

  $(document).on('click', '.js-delete-custom', function (e) {
    e.preventDefault();
    let data_id = $(this).attr('data-id');
    let data_title = $(this).attr('data-message-title');
    let data_content = $(this).attr('data-message-content');

    Swal.fire({
      title: data_title,
      text: data_content,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#9C63FF',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, excluir!',
      cancelButtonText: 'Não excluir',
    }).then(result => {
      if (result.value) {
        var token = $('meta[name="csrf-token"]').attr('content');

        $.ajax({
          headers: {
            'X-CSRF-TOKEN': token,
          },
          url: $(this).attr('data-url'),
          method: 'DELETE',
          success: function (data) {
            Swal.fire(data.title, data.message, data.type);

            if (data.type == 'success') {
              var row = document.getElementById(data_id);
              row.parentNode.removeChild(row);

              if (data.count) {
                $('.js-counter').html(data.count);
              }
            }
          },
        });
      }
    });
  });

  (function ($) {
    $.fn.inputFilter = function (inputFilter) {
      return this.on('input keydown keyup mousedown mouseup select contextmenu drop', function () {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty('oldValue')) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        } else {
          this.value = '';
        }
      });
    };
  })(jQuery);

  $('.js-number').inputFilter(function (value) {
    return /^\d*$/.test(value);
  });

  $('.file-input').change(function () {
    $('#label_' + this.name).text(this.files[0].name);
  });

  $selectSuper.on('change', function (e) {
    e.preventDefault();

    var post = {};

    $selectRegional.empty();
    $selectRegional.append($('<option></option>').attr('value', '').text('Carregando...'));

    post.id = $selectSuper.val();
    post._token = $('meta[name="csrf-token"]').attr('content');

    var url = '/busca-regionais/' + post.id;

    $.ajax({
      type: 'GET',
      url: url,
      data: post,
      cache: false,
      dataType: 'json',
      success: function (data) {
        if (data) {
          $selectRegional.empty();

          $selectRegional.append($('<option></option>').attr('value', '0').text('Selecione sua regional'));
          $.each(data, function (index, element) {
            $selectRegional.append($('<option></option>').attr('value', index).text(element));
          });
        }
      },
    });
  });

  const $customCheck = $('[data-custom-check]');

  $customCheck.on('click', function (e) {
    const $check = $(this).find('input[type="checkbox"]');

    let $status = 0;

    if ($($check).is(':checked')) {
      $check.prop('checked', false);
    } else {
      $check.prop('checked', true);
      $status = 1;
    }

    let url = $(this).attr('data-url');
    var post = {};
    post.receive_notifications = $status;
    post._token = $('meta[name="csrf-token"]').attr('content');

    $.ajax({
      type: 'POST',
      url: url,
      data: post,
      cache: false,
      dataType: 'json',
      success: function (data) {
        if (data.success) {
          Swal.fire(data.title, data.message, data.type);
        }
      },
    });
  });

  // Máscara de diversos inputs,
  // Função dispara no focus para contemplar elementos inseridos após o carregamento do JS
  // EX: formulários de ação

  $(document).on('focus', '.js-form-cnpj', function () {
    $(this).mask('99.999.999/9999-99');
  });
  $(document).on('focus', '.js-form-cpf', function () {
    $(this).mask('999.999.999-99');
  });
  $(document).on('focus', '.js-form-date', function () {
    $(this).mask('99/99/9999');
  });
  $(document).on('focus', '.js-form-datetime', function () {
    $(this).mask('99/99/9999 99:99');
  });
  $(document).on('focus', '.js-form-hour', function () {
    $(this).mask('99:99');
  });
  $(document).on('focus', '.js-form-ddd', function () {
    $(this).mask('(99)');
  });
  $(document).on('focus', '.js-form-phone', function () {
    $(this).mask('(99) 99999.9999');
  });
  $(document).on('focus', '.js-form-phone-commercial', function () {
    $(this).mask('(99) 9999.9999');
  });
  $(document).on('focus', '.js-form-number', function () {
    $(this).mask('999999999999999');
  });
  $(document).on('focus', '.js-form-numeric-range', function () {
    $(this).mask('999999999999999');
  });
  $(document).on('focus', '.js-form-enrollment', function () {
    $(this).mask('9999999');
  });
  $(document).on('focus', '.js-form-money', function () {
    $(this).mask('#.##0,00', { reverse: true });
  });
};
